import { Pipe, PipeTransform } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';
import {
  exEditAdjustmentStringsByName,
  EX_EDIT_ADJUSTMENT_KEY
} from './ex-edit-adjustment-strings';

@Pipe({
  name: 'exEditAdjustmentString'
})
export class ExEditAdjustmentStringsPipe implements PipeTransform {
  transform(
    value: EX_EDIT_ADJUSTMENT_KEY,
    showAdminStrings: boolean,
    subProject: SubProject
  ): string {
    const toReturn = exEditAdjustmentStringsByName.get(value);
    return toReturn == null
      ? `${value} niet gedefinieerd`
      : showAdminStrings
      ? this.calculateValue(toReturn.adminValue, subProject)
      : this.calculateValue(toReturn.clientValue, subProject);
  }

  private calculateValue(
    clientAdminValue: string | ((...i: any) => string),
    subProject: SubProject
  ): string {
    return typeof clientAdminValue === 'string'
      ? clientAdminValue
      : clientAdminValue(subProject);
  }
}
